import { apiClient } from "../../shared/api/clients";

/** Structure retournée par le backend pour une requête sauvegardée */
export interface SavedQuery {
  id: number;
  userId: number; // propriétaire de la requête (lecture seule)
  name: string;
  cubeName: string;
  measures: string[];
  rowsDimensions: any[];
  columnsDimensions: any[];
  dateFrom: string | null;
  dateTo: string | null;
  topN: number | null;
  type: string | null;
  section: string | null;
  demarquePhase?: string | null;
  createdAt: string;
  updatedAt: string;
}

/** Corps de la requête POST / PUT */
export interface SaveQueryRequest {
  name: string;
  cubeName?: string;
  measures: string[];
  rowsDimensions: any[];
  columnsDimensions: any[];
  dateFrom?: string | null;
  dateTo?: string | null;
  topN?: number | null;
  type: string | null;
  section: string | null;
  demarquePhase?: string | null;
}

export const getSavedQueries = () => apiClient.get<SavedQuery[]>("/saved-queries");

export const getSavedQueryById = (id: number) =>
  apiClient.get<SavedQuery>(`/saved-queries/${id}`);

export const createSavedQuery = (req: SaveQueryRequest) =>
  apiClient.post<SavedQuery>("/saved-queries", req);

export const updateSavedQuery = (id: number, req: Partial<SaveQueryRequest>) =>
  apiClient.put<SavedQuery>(`/saved-queries/${id}`, req);

export const deleteSavedQuery = (id: number) =>
  apiClient.delete(`/saved-queries/${id}`);
